<template>
  <div>
    <PageHeader/>

    <h1 class="text-center responsive">
      <img v-if="getBrewery === 'alesong' && !isSuccessPage" class="alesong-image" src="../assets/images/alesong_logo.png">
      <img v-if="getBrewery === 'degarde' && !isSuccessPage" class="degarde-image" src="../assets/images/degarde_logo.png">
      <img v-if="getBrewery === 'sapwoodCellars' && !isSuccessPage" class="sapwoodCellars-image" src="../assets/images/sapwoodCellars_logo.png">
      <img v-if="getBrewery === 'pfriemstersCellarClub' && !isSuccessPage" class="pfriemsters-image" src="../assets/images/pfriemsters-CellarClub.png">
      <img v-if="getBrewery === 'pfriemstersArtisanClub' && !isSuccessPage" class="pfriemsters-image" src="../assets/images/pfriemsters-ArtisanClub.png">
      <img v-if="getBrewery === 'aleApothecary' && !isSuccessPage" class="ale-apothecary-image" src="../assets/images/ale_apothecary_join_us.jpg">
      <img v-if="getBrewery === 'horusSkyGod' && !isSuccessPage" class="horus-sky-god-image" src="../assets/images/horusSkyGod.png">
      <img v-if="getBrewery === 'horusCrownedEagle' && !isSuccessPage" class="horus-crowned-eagle-image" src="../assets/images/horusCrownedEagle.png">
      <img v-if="getBrewery === 'sideProjectFarmClub' && !isSuccessPage" class="side-project-farm-club-image" src="../assets/images/SideProjectFarmClubLogo.png">
      <img v-if="getBrewery === 'celladorAlesSyndicate' && !isSuccessPage" class="cellador-ales-syndicate-image" src="../assets/images/SyndicateLogo2026.png">
      <img v-if="getBrewery === 'cycleBenefactorsClub' && !isSuccessPage" class="cycle-benefactors-club-image" src="../assets/images/CycleBenefactorsClubLogo.png">
      <img v-if="getBrewery === 'fairIsleKnittingCircle' && !isSuccessPage" class="fair-isle-knitting-circle-image" src="../assets/images/fair_isle_knitting_circle_logo.png">
      <img v-if="getBrewery === 'pureProjectCellarC' && !isSuccessPage" class="pure-project-cellar-c-image" src="../assets/images/pure_project_cellar_c_logo.png">
      <img v-if="getBrewery === 'PerennialSociete' && !isSuccessPage" class="PerennialSociete-image" src="../assets/images/PerennialSociete_logo.png">
      {{pageTitleText}}
      <div v-if="pageTitleSubtext && !isSuccessPage" class="text-center responsive subtitle">{{pageTitleSubtext}}</div>
      <div v-if="pageTitleSubSubtext && !isSuccessPage" class="pure-u-1 summary sub-subtitle"  >
        <div class="pure-u-1 pure-u-md-3-5 pure-u-lg-1-2">
          {{ pageTitleSubSubtext }}
        </div>
      </div>
    </h1>


    <h2 v-if="busy">loading...</h2>

    <component v-bind:is="currentView" :sso="currentView === 'Login'" @success="setView"  @login="routeLogin" @register="routeZipAndAge"/>


  </div>
</template>

<script>
  import store from '../lib/store';
  import * as sso from '../lib/sso';
  import PageHeader from '../components/helpers/PageHeader';
  import Login from '../components/start/Login';
  import ZipAndAgeDirect from '../components/start/ZipAndAgeDirect';
  import StepsDirect from '../components/StepsDirect';
  import SuccessAlesong from '../components/success/SuccessAlesong';
  import SuccessDegarde from '../components/success/SuccessDegarde';
  import SuccessSapwoodCellars from '../components/success/SuccessSapwoodCellars';
  import SuccessPfriemstersCellarClub from '../components/success/SuccessPfriemstersCellarClub';
  import SuccessPfriemstersArtisanClub from '../components/success/SuccessPfriemstersArtisanClub';
  import SuccessAleApothecary from '../components/success/SuccessAleApothecary';
  import SuccessFairIsleKnittingCircle from '../components/success/SuccessFairIsleKnittingCircle';
  import SuccessPureProjectCellarC from '../components/success/SuccessPureProjectCellarC';
  import SuccessPerennialSociete from '../components/success/SuccessPerennialSociete';
  import SuccessHorusSkyGod from '../components/success/SuccessHorusSkyGod';
  import SuccessHorusCrownedEagle from '../components/success/SuccessHorusCrownedEagle';
  import SuccessSideProjectFarmClub from '../components/success/SuccessSideProjectFarmClub';
  import SuccessCelladorAlesSyndicate from '../components/success/SuccessCelladorAlesSyndicate';
  import SuccessCycleBenefactorsClub from '../components/success/SuccessCycleBenefactorsClub';

  export default {
    name: 'HomeDirect',
    components: {
      PageHeader,
      Login,
      ZipAndAgeDirect,
      StepsDirect,
      SuccessAlesong,
      SuccessDegarde,
      SuccessSapwoodCellars,
      SuccessPfriemstersCellarClub,
      SuccessPfriemstersArtisanClub,
      SuccessAleApothecary,
      SuccessFairIsleKnittingCircle,
      SuccessPureProjectCellarC,
      SuccessPerennialSociete,
      SuccessHorusSkyGod,
      SuccessHorusCrownedEagle,
      SuccessSideProjectFarmClub,
      SuccessCelladorAlesSyndicate,
      SuccessCycleBenefactorsClub,
    },
    data() {
      return {
        busy: false,
        currentView: 'ZipAndAgeDirect',
      };
    },
    created() {
      // Back from a Google / Apple sign-in: continue where the member left off.
      const result = sso.takeResult();
      if (!result) return;
      if (result.zipCode) store.set('zipCode', result.zipCode);
      if (!result.signedIn) {
        // Cancelled or failed: the Google / Apple buttons show any error.
        this.currentView = result.zipCode ? 'StepsDirect' : 'Login';
        return;
      }
      store.set('ssoNewUser', result.newUser);
      // A new account still needs the delivery area and age check. An existing
      // member skips it, like an email login does.
      this.currentView = (result.zipCode || !result.newUser) ? 'StepsDirect' : 'ZipAndAgeDirect';
    },
    methods: {
      setView() {
        let res;
        switch (this.currentView) {
          case 'Start':
            if (store.get('authToken')) {
              res = 'StepsDirect';
            } else {
              res = 'ZipAndAgeDirect';
            }
            break;
          case 'ZipAndAgeDirect':
            res = 'StepsDirect';
            break;
          case 'Login':
            res = 'StepsDirect';
            break;
          case 'LoginDirect':
            res = 'StepsDirect';
            break;
          case 'StepsDirect':
            res = this.chooseSuccessPage();
            break;
          default:
          // do nothing
        }
        this.currentView = res;
      },
      chooseSuccessPage() {
        let res;
        switch (store.get('brewery')) {
          case 'alesong':
            res = 'SuccessAlesong';
            break;
          case 'degarde':
            res = 'SuccessDegarde';
            break;
          case 'sapwoodCellars':
            res = 'SuccessSapwoodCellars';
            break;
          case 'pfriemstersCellarClub':
            res = 'SuccessPfriemstersCellarClub';
            break;
          case 'pfriemstersArtisanClub':
            res = 'SuccessPfriemstersArtisanClub';
            break;
          case 'fairIsleKnittingCircle':
            res = 'SuccessFairIsleKnittingCircle';
            break;
          case 'aleApothecary':
            res = 'SuccessAleApothecary';
            break;
          case 'pureProjectCellarC':
            res = 'SuccessPureProjectCellarC';
            break;
          case 'PerennialSociete':
            res = 'SuccessPerennialSociete';
            break;
          case 'HorusSkyGod':
            res = 'SuccessHorusSkyGod';
            break;
          case 'HorusCrownedEagle':
            res = 'SuccessHorusCrownedEagle';
            break;
          case 'SideProjectFarmClub':
            res = 'SuccessSideProjectFarmClub';
            break;
          case 'celladorAlesSyndicate':
            res = 'SuccessCelladorAlesSyndicate';
            break;
          case 'cycleBenefactorsClub':
            res = 'SuccessCycleBenefactorsClub';
            break;
          default:
          // do nothing
        }
        return res;
      },
      routeLogin() {
        this.currentView = 'Login';
      },
      routeZipAndAge() {
        this.currentView = 'ZipAndAgeDirect';
      },
    },
    computed: {
      pageTitleText() {
        if (this.currentView.includes('Success')) {
          return store.get('title_success');
        }
        return store.get('title_in_progress');
      },
      getBrewery() {
        return store.get('brewery');
      },
      pageTitleSubtext() {
        const subtext = store.get('title_subtext');
        if (subtext) {
          return subtext;
        }
        return false;
      },
      pageTitleSubSubtext() {
        const subSubtext = store.get('title_sub_subtext');
        if (subSubtext) {
          return subSubtext;
        }
        return false;
      },
      isSuccessPage() {
        return this.currentView.includes('Success');
      },
    },
  };
</script>

<style scoped>
  .subtitle {
    font-size: 18px;
  }
  .sub-subtitle {
    font-size: 16px;
  }

  .degarde-image {
    height: 200px;
    width: 230px;
    margin-bottom: -18px;
  }
  @media screen and (max-width: 35.5em) {
    .degarde-image {
      height: 200px;
      width: 230px;
      margin-bottom: 0;
    }
  }

  .alesong-image {
    height: 80px;
    width: 230px;
    margin-bottom: -18px;
  }
  @media screen and (max-width: 35.5em) {
    .alesong-image {
      height: 80px;
      width: 230px;
      margin-bottom: 0;
    }
  }

  .sapwoodCellars-image {
    height: 200px;
    width: 200px;
    margin-bottom: -18px;
  }
  @media screen and (max-width: 35.5em) {
    .sapwoodCellars-image {
      height: 200px;
      width: 200px;
      margin-bottom: 0;
    }
  }

  .pfriemsters-image {
    height: 200px;
    width: auto;
  }
  @media screen and (max-width: 35.5em) {
    .pfriemsters-image {
      height: 200px;
      width: auto;
    }
  }

  .ale-apothecary-image {
    height: 200px;
    width: auto;
  }
  @media screen and (max-width: 35.5em) {
    .ale-apothecary-image {
      height: 200px;
      width: auto;
    }
  }

  .fair-isle-knitting-circle-image {
    height: 200px;
    width: auto;
  }
  @media screen and (max-width: 35.5em) {
    .fair-isle-knitting-circle-image {
      height: 200px;
      width: auto;
    }
  }

  .pure-project-cellar-c-image {
    height: 150px;
    width: auto;
  }
  @media screen and (max-width: 35.5em) {
    .pure-project-cellar-c-image {
      height: 150px;
      width: auto;
    }
  }

  .PerennialSociete-image {
    height: 150px;
    width: auto;
  }
  @media screen and (max-width: 35.5em) {
    .PerennialSociete-image {
      height: 150px;
      width: auto;
    }
  }

  .horus-sky-god-image {
    height: 209px;
    width: 209px;
  }
  @media screen and (max-width: 35.5em) {
    .horus-sky-god-image {
      height: 209px;
      width: 209px;
    }
  }

  .horus-crowned-eagle-image {
    height: 209px;
    width: 209px;
  }
  @media screen and (max-width: 35.5em) {
    .horus-crowned-eagle-image {
      height: 209px;
      width: 209px;
    }
  }

  .side-project-farm-club-image {
    height: 209px;
    width: auto;
  }
  @media screen and (max-width: 35.5em) {
    .side-project-farm-club-image {
      height: 209px;
      width: auto;
    }
  }

  .cellador-ales-syndicate-image {
    height: 209px;
    width: auto;
  }
  @media screen and (max-width: 35.5em) {
    .cellador-ales-syndicate-image {
      height: 209px;
      width: auto;
    }
  }

  .cycle-benefactors-club-image {
    height: 209px;
    width: auto;
  }
  @media screen and (max-width: 35.5em) {
    .cycle-benefactors-club-image {
      height: 209px;
      width: auto;
    }
  }

</style>



// WEBPACK FOOTER //
// HomeDirect.vue?1985384e